import script from "./AccountSettingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountSettingsPage.vue?vue&type=script&setup=true&lang=js"

import "./AccountSettingsPage.vue?vue&type=style&index=0&id=c7a64f1e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7a64f1e"]])

export default __exports__